<template>
	<dms-wrapper :label="labelMultiText" v-bind="{...$attrs, labelKey, wrapp, span, showLabel, validationRules}" :validation-property="validationPropertyCmp"
		:disabled="isDisabled">
		<el-row :class="{'frm-nowrap-group': !wrap}" type="flex" class="frm-subgroup frm-input-group">
			<slot />
		</el-row>
	</dms-wrapper>
</template>

<script>
import { snakeToPascalCase } from '@/main/utils/stringHelper';

import { DmsBaseComponent } from '#components/dms/common/base';
import DmsWrapper from '#components/dms/form/Wrapper.vue';

export default DmsBaseComponent.extend({
	name: 'DmsGroup',
	components: { DmsWrapper },
	props: {
		labelMultiKey: String,
		labelMulti: String,
		showLabel: { type: Boolean, default: true },
		wrap: { type: Boolean, default: true },
		wrapp: { type: Boolean, default: true },
		validationProperty: String,
		validationRules: [Object, Array],
		validationOff: { type: Boolean, default: true },
		span: { type: Number, default: 24 },
	},
	computed: {
		labelMultiText() {
			if (this.showLabel) {
				return this.getText(this.labelMulti, this.labelMultiKey, null, this.LocalizeMultiKey);
			}
			return null;
		},
		validationPropertyCmp() {
			return this.validationOff
				? undefined
				: (this.validationProperty || snakeToPascalCase(this.labelKey));
		},
	},
});
</script>
